import { httpGet } from "../services/apiService";
import Fuse from "fuse.js"

export const otrosModule = {
    state: () => ({
        fetchingOtros: false,
        errorFetchingOtros: false,
        allOtros: [],
        selectedOtros: [],
        fuseOtros: [],
        totalOtros: 0,
        totalPesoOtros: 0,
    }),
    mutations: {
        setFetchingOtros(state, newValue) {
            state.fetchingOtros = newValue;
        },
        setErrorFetchingOtros(state, newValue) {
            state.errorFetchingOtros = newValue;
        },
        setAllOtros(state, newValue) {
            state.allOtros = newValue;
        },
        setSelectedOtros(state, newValue) {
            state.selectedOtros = newValue;
        },
        setFuseOtros(state, newValue) {
            state.fuseOtros = newValue;
        },
        setTotalOtros(state, newValue) {
            state.totalOtros = newValue;
        },
        setTotalPesoOtros(state, newValue) {
            state.totalPesoOtros = newValue;
        },
    },
    actions: {
        async getOtros({ state, commit }) {
            const { data } = await httpGet("/productos?filters[familia][$eq]=otros&populate=subfamilia");
            ("Otros:", data?.data);
            commit("setAllOtros", data?.data);
            commit("setFuseOtros", new Fuse([...state.allOtros], {
                keys: ["attributes.codigo", "attributes.descripcion"],
            }));
        },
        async addOtro({ state, rootState, commit }, newValue) {
            const valorFlete = 1;

            // Flatten product object
            let newEntry = {
                ...newValue.attributes,
                id: newValue.id,
                cantidad: 1,
                largo: 1,
            };

            // Set unit options.
            let unitOptions = [];
            for (const f in newEntry.factores) {
                if (Object.hasOwnProperty.call(newEntry.factores, f)) {
                    const element = newEntry.factores[f];
                    unitOptions.push({ text: element.referencia, value: element });
                }
            }

            newEntry.unit_options = unitOptions.filter(u => u.value.activo == true);
            newEntry.selected_unit = newEntry.unit_options[0].value ?? null;

            // Set discounts
            newEntry.minDiscount = 0;
            newEntry.maxDiscount = 100;
            if (rootState.client?.selectedClient == null) {
                newEntry.descuento_seleccionado = 0;
            }
            else {
                const discount = rootState?.client?.processedDiscounts?.filter(d => d?.subfamilia?.id == newEntry?.subfamilia?.data?.id);

                if (discount != null && discount.length > 0) {
                    newEntry.descuento_seleccionado = discount[0]?.valor;
                }
                else {
                    newEntry.descuento_seleccionado = 0;
                }
            }

            // Set calculated price fields.
            newEntry.precio_provicional_uno = newEntry.precio_lista / newEntry.factores.metro_cuadrado.valor;
            newEntry.precio_provicional_dos = newEntry.precio_provicional_uno * (1 - newEntry.descuento_seleccionado / 100)
            newEntry.flete_provicional = (valorFlete * newEntry.factores.kilogramo.valor) / newEntry.factores.metro_cuadrado.valor;
            newEntry.precio_unitario_final = (newEntry.precio_provicional_dos + newEntry.flete_provicional) * newEntry.largo;
            newEntry.total_local = newEntry.precio_unitario_final * newEntry.cantidad;

            // Set calculated weight fields.
            newEntry.peso_calculado = newEntry.cantidad * (newEntry.selected_unit.peso_por_unidad ?? 0) * newEntry.largo;

            // Set discounts
            newEntry.minDiscount = 0;
            newEntry.maxDiscount = 100;

            if (newEntry.selected_unit.peso_por_unidad == null) {
                commit("setWarningsPeso", [...rootState.warningsPeso, newEntry]);
            }

            ("new otro:", newEntry);
            commit("setSelectedOtros", [...state.selectedOtros, newEntry]);
        },
        updateOtros({ state, rootState, commit }, item) {
            const valorFlete = rootState?.destinies?.selectedDestiny?.attributes?.valor_flete;

            if (item.descuento_seleccionado >= item.maxDiscount) {
                item.descuento_seleccionado = item.maxDiscount;
            }
            if (item.descuento_seleccionado <= item.minDiscount) {
                item.descuento_seleccionado = 0;
            }

            // Set calculated price fields.
            item.precio_provicional_uno = item.precio_lista / item.factores.metro_cuadrado.valor;
            item.precio_provicional_dos = item.precio_provicional_uno * (1 - item.descuento_seleccionado / 100)
            item.flete_provicional = (valorFlete * item.factores.kilogramo.valor) / item.factores.metro_cuadrado.valor;
            item.precio_unitario_final = (item.precio_provicional_dos + item.flete_provicional) * item.largo;
            item.total_local = item.precio_unitario_final * item.cantidad;

            // Set calculated weight fields.
            item.peso_calculado = item.cantidad * (item.selected_unit.peso_por_unidad ?? 0) * item.largo;

            commit('setSelectedOtros', [...state.selectedOtros]);
        },
        deleteOtro({ state, rootState, commit }, product) {
            commit("setSelectedOtros", state.selectedOtros.filter(p => p.id != product.id));
            commit("setWarningsPeso", rootState.warningsPeso.filter(p => p.id != product.id));
        },
    }
}